export function getNomePropriedade(objeto, valor) {
  for (const propriedade in objeto) {
    if (objeto[propriedade] === valor) {
      return propriedade;
    }
  }
  return null;
}

export function transformaTextoCamelCase(nome) {
  const separador = /\s+/g;
  const palavras = nome.toLowerCase().split(separador);
  const nomeCamelCase = palavras.map(palavra => {
    return palavra.charAt(0).toUpperCase() + palavra.slice(1);
  }).join('');
  return (nomeCamelCase.slice(0, 1).toLowerCase() + nomeCamelCase.slice(1)).normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(/[a-zA-Z0-9]/g).join('');
}

export function extrairETruncarNumeros(valor, qntCaracteres) {
  const valorEmString = valor.toString();
  const numeros = valorEmString.match(/\d+/g);
  if (numeros) {
    return numeros.map(num => num.slice(0, qntCaracteres)).join('');
  } else {
    return '';
  }
}

export function aplicaMascara(value, mask) {
  if (!value) {
    return '';
  }

  value = value.replace(/\D/g, '');

  let maskedValue = '';
  let inputIndex = 0;

  for (let i = 0; i < mask.length; i++) {
    const maskChar = mask[i];

    if (maskChar === 'X') {
      if (inputIndex < value.length) {
        maskedValue += value[inputIndex];
        inputIndex++;
      } else {
        break;
      }
    } else {
      if (inputIndex < value.length) {
        maskedValue += maskChar;
      } else {
        break;
      }
    }
  }

  return maskedValue;
}


export function formatoMascaras() {
  return {
    CNPJ: 'XX.XXX.XXX/XXXX-XX',
    CPF: 'XXX.XXX.XXX-XX',
    CEP: 'XXXXX-XXX',
    TEL: '(XX) XXXXX-XXXX',
    RG: 'XX.XXX.XXX-X',
    RGNovo: 'XXXXXXXXXX-X',
    CNH: 'XXXXXXXXXXX',
    PIS: 'XXX.XXXXX.XX-X',
  };
}

export function validarEmail(email) {
  if (!email) return false;
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regexEmail.test(email);
}

export function converterDataParaISO(dataString) {
  try {
    const partesData = dataString.split('/');
    const dia = parseInt(partesData[0]);
    const mes = parseInt(partesData[1]) - 1;
    const ano = parseInt(partesData[2]);

    const data = new Date(ano, mes, dia);
    const dataISO = data.toISOString();
    const dataISOFormatada = dataISO.slice(0, 19);

    return dataISOFormatada;
  } catch (error) {
    return dataString
  }
}

export function capitalizarPropriedades(obj) {

  if (typeof obj !== 'object' || obj === null) {
    console.error('Entrada inválida: deve ser um objeto.');
    return;
  }

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (typeof value === 'string') {
        obj[key] = value.toUpperCase();
      } else if (typeof value === 'object') {
        capitalizarPropriedades(value);
      }
    }
  }

  return obj;
}

export async function resizeImage(file, tamanhoMaximoArquivo) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();

    reader.onload = (e) => {
      img.src = e.target.result;
    };
    reader.onerror = (e) => {
      reject(e);
    };

    img.onload = () => {
      let quality = 0.9;
      let qualityAttempts = 0;
      let canvas = document.createElement('canvas');
      let width = img.width;
      let height = img.height;
      const ctx = canvas.getContext('2d');

      const processCompression = () => {
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob((blob) => {
          if (!blob) {
            reject(new Error("Erro ao criar blob"));
            return;
          }
          if (blob.size > tamanhoMaximoArquivo) {
            if (qualityAttempts < 3) {
              qualityAttempts++;
              quality -= 0.1;
              processCompression();
            } else {
              width = Math.round(width * 0.5);
              height = Math.round(height * 0.5);
              processCompression();
            }
          } else {
            const newFile = new File([blob], file.name, { type: file.type });
            resolve(newFile);
          }
        }, file.type, quality);
      };

      processCompression();
    };

    img.onerror = (err) => {
      reject(err);
    };

    reader.readAsDataURL(file);
  });
};


function onlyNumbers(value) {
  return value.replace(/\D/g, '');
}

export function validateCNPJ(cnpj) {
  if (cnpj == undefined) return false;

  cnpj = onlyNumbers(cnpj);
  if (cnpj.length !== 14) return false;

  var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
  var c = String(cnpj).replace(/[^\d]/g, '')

  if (c.length !== 14)
    return false
  if (/0{14}/.test(c))
    return false
  for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
  if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
    return false
  for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
  if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
    return false
  return true
}

export function validateCPF(cpf) {
  if (cpf == undefined) return false;
  cpf = onlyNumbers(cpf);
  if (typeof cpf !== "string") return false
  cpf = cpf.replace(/[\s.-]*/igm, '')
  if (
    !cpf ||
    cpf.length != 11 ||
    cpf == "00000000000" ||
    cpf == "11111111111" ||
    cpf == "22222222222" ||
    cpf == "33333333333" ||
    cpf == "44444444444" ||
    cpf == "55555555555" ||
    cpf == "66666666666" ||
    cpf == "77777777777" ||
    cpf == "88888888888" ||
    cpf == "99999999999"
  ) {
    return false
  }
  var soma = 0
  var resto
  for (var i = 1; i <= 9; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
  resto = (soma * 10) % 11
  if ((resto == 10) || (resto == 11)) resto = 0
  if (resto != parseInt(cpf.substring(9, 10))) return false
  soma = 0
  for (var i = 1; i <= 10; i++)
    soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i)
  resto = (soma * 10) % 11
  if ((resto == 10) || (resto == 11)) resto = 0
  if (resto != parseInt(cpf.substring(10, 11))) return false
  return true
}

// export function capitalizarPropriedades(obj, capitalizeKeys = false, capitalizeValues = true) {

//   if (typeof obj !== 'object' || obj === null) {
//     console.error('Entrada inválida: deve ser um objeto.');
//     return;
//   }

//   function padronizarData(data) {
//     return new Date(data).toISOString();
//   }

//   for (const key in obj) {
//     if (obj.hasOwnProperty(key)) {
//       const value = obj[key];

//       if (typeof value === 'string') {
//         if (capitalizeKeys) {
//           obj[key.toUpperCase()] = value;
//           delete obj[key]; // Remover a chave original
//         }
//         if (capitalizeValues) {
//           obj[key.toUpperCase()] = value.toUpperCase();
//         }
//       } else if (typeof value === 'object') {
//         capitalizarPropriedades(value, capitalizeKeys, capitalizeValues);
//       } else if (typeof value === 'date') {
//         // obj[key] = padronizarData(value);
//       }
//     }
//   }

//   return obj;
// }

/**
 * Obtém informações do navegador e sistema operacional do usuário
 * @returns {Object} { navegador, sistemaOperacional, userAgent }
 */
export function obterInfoNavegador() {
    try {
        const ua = navigator.userAgent || '';
        let navegador = 'Desconhecido';
        let sistemaOperacional = 'Desconhecido';

        // Detectar navegador (ordem importa - Chrome contém Safari no UA)
        if (ua.indexOf('Edg') > -1 || ua.indexOf('Edge') > -1) {
            navegador = 'Edge';
        } else if (ua.indexOf('Opera') > -1 || ua.indexOf('OPR') > -1) {
            navegador = 'Opera';
        } else if (ua.indexOf('Chrome') > -1) {
            navegador = 'Chrome';
        } else if (ua.indexOf('Firefox') > -1) {
            navegador = 'Firefox';
        } else if (ua.indexOf('Safari') > -1) {
            navegador = 'Safari';
        } else if (ua.indexOf('Trident') > -1 || ua.indexOf('MSIE') > -1) {
            navegador = 'Internet Explorer';
        }
        // Detectar sistema operacional
        if (ua.indexOf('Windows NT 10.0') > -1) sistemaOperacional = 'Windows 10/11';
        else if (ua.indexOf('Windows NT 6.3') > -1) sistemaOperacional = 'Windows 8.1';
        else if (ua.indexOf('Windows NT 6.2') > -1) sistemaOperacional = 'Windows 8';
        else if (ua.indexOf('Windows NT 6.1') > -1) sistemaOperacional = 'Windows 7';
        else if (ua.indexOf('Windows') > -1) sistemaOperacional = 'Windows';
        else if (ua.indexOf('Mac OS X') > -1) sistemaOperacional = 'MacOS';
        else if (ua.indexOf('Linux') > -1) sistemaOperacional = 'Linux';
        else if (ua.indexOf('Android') > -1) sistemaOperacional = 'Android';
        else if (ua.indexOf('iOS') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) {
            sistemaOperacional = 'iOS';
        }

        // Limitar tamanho do userAgent para segurança (max 500 caracteres)
        const userAgentTruncado = ua.length > 500 ? ua.substring(0, 500) + '...' : ua;

        return {
            navegador,
            sistemaOperacional,
            userAgent: userAgentTruncado
        };
    } catch (error) {
        // Fallback seguro em caso de erro
        console.warn('Erro ao obter informações do navegador:', error);
        return {
            navegador: 'Erro ao detectar',
            sistemaOperacional: 'Erro ao detectar',
            userAgent: 'Indisponível'
        };
    }
}